<app-navbar></app-navbar>
<router-outlet />
